var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventNoteBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 0.5H3.83333C1.99238 0.5 0.5 1.99238 0.5 3.83333V12.1667C0.5 14.0076 1.99238 15.5 3.83333 15.5H12.1667C14.0076 15.5 15.5 14.0076 15.5 12.1667V3.83333C15.5 1.99238 14.0076 0.5 12.1667 0.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventNoteBox);
export default __webpack_public_path__ + "static/media/event-note-box.60f85977d1944b011a8f175d8766e73f.svg";
export { ForwardRef as ReactComponent };